import axios from '../axios';

const posSessionApi = {
  startSession: (data) => axios.post('/PosSessions/start', data),
  getCurrentSession: () => axios.get('/PosSessions/current'),
  getSessionSummary: () => axios.get('/PosSessions/summary'),
  closeSession: (data) => axios.post('/PosSessions/close', data),
  getSessionHistory: (params) => axios.get('/PosSessions/history', { params }),
};

export default posSessionApi;
